import { mvpApiGetPlanogramProductOptions } from "@labeling-tools/api/atlas/@tanstack/react-query.gen";
import { useClickOutside } from "../../utils/use-click-outside";
import { useQuery } from "@tanstack/react-query";
import { useCallback, useRef } from "react";
import {
  activeLabelBoxWidth,
  useActivePlanoProductInfoStore,
} from "../use-active-plano-product-info-store";
import { PlanogramProduct } from "../../PlanogramProduct";

interface Props {
  planogram_id: string;
  activePlanogramProductId: string;
  enable_product_id_copy: boolean;
  // onSelectProduct: (product_id: string) => void;
}

export const ActivePlanoProductPopover = (props: Props) => {
  const {
    planogram_id,
    activePlanogramProductId,
    enable_product_id_copy = false,
  } = props;
  const activeProductId = useActivePlanoProductInfoStore(
    (s) => s.productBoxInfo.product_id,
  );

  const top = useActivePlanoProductInfoStore((s) => s.productBoxInfo.top);
  const left = useActivePlanoProductInfoStore((s) => s.productBoxInfo.left);
  // const uuid = useActivePlanoProductInfoStore((s) => s.productBoxInfo.planogram_product_id);

  const ref = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback((event: MouseEvent | TouchEvent) => {
    // Ignore clicks inside any PlanogramModal
    const target = event.target as HTMLElement;
    if (
      target.closest("[data-planogram-modal]") ||
      target.closest("[data-item-verification]")
    )
      return;

    const {
      setActiveLabelBoxInfo,
      mouseDownUuid,
      productBoxInfo: labelBoxInfo,
    } = useActivePlanoProductInfoStore.getState();

    if (mouseDownUuid === labelBoxInfo.planogram_product_id) return;
    setActiveLabelBoxInfo({
      top: 0,
      left: 0,
      planogram_product_id: "",
      product_id: "",
    });
  }, []);

  useClickOutside(ref, handleClickOutside);

  const { data: productResp } = useQuery({
    ...mvpApiGetPlanogramProductOptions({
      path: { planogram_id, planogram_product_id: activePlanogramProductId },
    }),
    enabled: !!planogram_id && !!activePlanogramProductId,
  });

  return (
    <div
      ref={ref}
      className="absolute top-0 left-0 min-h-[250px] max-w-full rounded-lg border border-gray-400 bg-white z-[110]"
      style={{
        top: top + "px",
        left: left + "px",
        visibility: !activeProductId ? "hidden" : "visible",
        width: activeLabelBoxWidth,
      }}
    >
      {!!productResp && (
        <PlanogramProduct
          enable_product_id_copy={enable_product_id_copy}
          selectedProduct={productResp}
          key={activePlanogramProductId}
        />
      )}
    </div>
  );
};
